import { supabase } from "../../supabaseClient";


async function getAccessToken() {
  let {
    data: {
      session,
    },
    error,
  } =
    await supabase.auth
      .getSession();


  if (error) {
    throw error;
  }


  if (
    !session?.access_token
  ) {
    const refresh =
      await supabase.auth
        .refreshSession();


    if (
      refresh.error
    ) {
      throw refresh.error;
    }


    session =
      refresh.data
        ?.session ||
      null;
  }


  if (
    !session?.access_token
  ) {
    throw new Error(
      "Admin session is missing."
    );
  }


  return session.access_token;
}


export async function fetchAdminNotificationOverview() {
  const {
    data,
    error,
  } =
    await supabase
      .rpc(
        "admin_get_notification_overview"
      )
      .maybeSingle();


  if (error) {
    throw error;
  }


  return {
    notifications_enabled_count:
      Number(
        data
          ?.notifications_enabled_count
      ) || 0,

    permission_granted_count:
      Number(
        data
          ?.permission_granted_count
      ) || 0,

    permission_denied_count:
      Number(
        data
          ?.permission_denied_count
      ) || 0,

    preference_disabled_count:
      Number(
        data
          ?.preference_disabled_count
      ) || 0,

    subscribed_user_count:
      Number(
        data
          ?.subscribed_user_count
      ) || 0,

    active_device_count:
      Number(
        data
          ?.active_device_count
      ) || 0,
  };
}


export async function fetchAdminNotificationTargets() {
  const {
    data,
    error,
  } =
    await supabase.rpc(
      "admin_get_notification_targets",
      {
        p_limit:
          1000,
      }
    );


  if (error) {
    throw error;
  }


  return Array.isArray(
    data
  )
    ? data.map(
        (row) => ({
          ...row,

          active_device_count:
            Number(
              row
                .active_device_count
            ) || 0,

          notifications_enabled:
            row
              .notifications_enabled ===
            true,
        })
      )
    : [];
}


export async function fetchAdminNotificationEvents() {
  const {
    data,
    error,
  } =
    await supabase.rpc(
      "admin_get_notification_events",
      {
        p_limit:
          100,

        p_offset:
          0,
      }
    );


  if (error) {
    throw error;
  }


  return Array.isArray(
    data
  )
    ? data
    : [];
}


export async function sendAdminPush({
  audience,
  userId,
  title,
  message,
  url,
}) {
  const token =
    await getAccessToken();


  const response =
    await fetch(
      "/.netlify/functions/admin-send-push",
      {
        method:
          "POST",

        headers: {
          "Content-Type":
            "application/json",

          Authorization:
            `Bearer ${token}`,
        },

        body:
          JSON.stringify({
            audience,

            user_id:
              audience ===
              "single_user"
                ? userId
                : null,

            title,
            message,
            url,

            urgency:
              "normal",
          }),
      }
    );


  const text =
    await response.text();


  let payload = {};

  try {
    payload =
      text
        ? JSON.parse(
            text
          )
        : {};
  } catch {
    payload = {};
  }


  if (
    !response.ok
  ) {
    throw new Error(
      payload?.error ||
        text ||
        `Notification send failed (${response.status}).`
    );
  }


  return payload;
}